import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Token } from '../../store/actions/user';

const PublicRoute = ({ component: Component }) => {
 return <Route render={(props) => (Token ? <Redirect to={{ pathname: '/' }} /> : <Component {...props} />)} />
};

export default PublicRoute;
